import React, { useEffect, useRef } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import { bind } from 'bind-event-listener';

import { componentWithFG } from '@atlaskit/platform-feature-flags-react';

const ElementEventListenerDeprecated = ({
	handler,
	children,
}: {
	children: React.ReactNode;
	handler?: () => void;
}) => {
	const wrapperRef = useRef<HTMLSpanElement>(null);

	useEffect(() => {
		if (!wrapperRef.current || !handler) {
			return;
		}

		const handleMouseDown = (e: MouseEvent) => {
			const isLink = (e.target as Element).closest('a');
			if (isLink && e.button !== 0) {
				handler();
			}
		};

		const unbind = bind(wrapperRef.current, {
			type: 'mousedown',
			listener: handleMouseDown,
		});

		return unbind;
	}, [handler]);

	return <span ref={wrapperRef}>{children}</span>;
};

const ElementEventListenerUpdated = ({
	onFocus,
	onMouseEnter,
	onRightClick,
	children,
}: {
	children: React.ReactNode;
	onFocus?: () => void;
	onMouseEnter?: () => void;
	onRightClick?: () => void;
}) => {
	const wrapperRef = useRef<HTMLSpanElement>(null);

	useEffect(() => {
		if (!wrapperRef.current || !onRightClick) {
			return;
		}

		const handleMouseDown = (e: MouseEvent) => {
			const isLink = (e.target as Element).closest('a');
			if (isLink && e.button !== 0) {
				onRightClick();
			}
		};

		const unbind = bind(wrapperRef.current, {
			type: 'mousedown',
			listener: handleMouseDown,
		});

		return unbind;
	}, [onRightClick]);

	return (
		<span ref={wrapperRef} onMouseEnter={onMouseEnter} onFocus={onFocus}>
			{children}
		</span>
	);
};

export const ElementEventListener = componentWithFG(
	'teams-shortcut-next-confluence',
	ElementEventListenerUpdated,
	ElementEventListenerDeprecated,
);
